import { Stack, IconButton, useTheme, Drawer, Box, Link } from '@mui/material';
import MenuIcon from '../../assets/menu.svg?react';
import CloseIcon from '../../assets/closeIcon.svg?react';
import { ReactNode, useState } from 'react';
import { Menubar } from '../Menubar';
import { branding } from '../../branding';
import { MobileUserMenu } from './MobileUserMenu';
import { TranslateButton } from '../TranslateButton';

interface MobileHeaderProps {
  menuItems: (onMenuItemClick?: () => void) => ReactNode;
  breadcrumb?: string;
}

export const MobileHeader = ({ menuItems, breadcrumb }: MobileHeaderProps) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const { logo } = branding;

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center" px={2} py={3}>
        <Link href="/">
          <Box component="img" src={logo} sx={{ height: '32px' }} />
        </Link>
        <Stack direction="row" spacing={2}>
          <TranslateButton />
          <IconButton color="secondary" sx={theme.mixins.roundedIconButton} onClick={toggleMenu}>
            {isOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        </Stack>
      </Stack>
      <Drawer
        anchor="right"
        open={isOpen}
        hideBackdrop
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: {
            mt: '100px',
            height: `calc(100vh - 100px)`,
            width: '100vw',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          },
        }}
      >
        <Stack direction="column" justifyContent="space-between" height="100%">
          <Menubar breadcrumb={breadcrumb}>{menuItems(() => setIsOpen(false))}</Menubar>
          <MobileUserMenu />
        </Stack>
      </Drawer>
    </>
  );
};
